import roles from 'config/roles/roles';
import features from 'config/features/features';
import linkIcons from 'helpers/linkIcons';

export interface Link {
  to: string;
  name: string;
  icon: JSX.Element;
  displayRoles: string[];
  displayFeature?: string;
}

const menuLinks: Link[] = [
  {
    to: '/',
    name: 'menu.dashboard',
    icon: linkIcons.dashboard,
    displayRoles: roles.user,
  },
  {
    to: '/employees',
    name: 'menu.employees',
    icon: linkIcons.employees,
    displayRoles: [...roles.employees, ...roles.employeesViewer],
    displayFeature: features.employees,
  },
  {
    to: '/human-resources',
    name: 'menu.human_resources',
    icon: linkIcons.hr,
    displayRoles: roles.humanResources,
  },
  {
    to: '/benefits',
    name: 'menu.benefits',
    icon: linkIcons.benefits,
    displayRoles: [...roles.benefitsManager, ...roles.benefitsViewer],
    displayFeature: features.benefits,
  },
  {
    to: '/holidays/me',
    name: 'menu.holidays_employee',
    icon: linkIcons.holidays,
    displayRoles: roles.user,
    displayFeature: features.holidays,
  },
  {
    to: '/holidays-management',
    name: 'menu.holidays_management',
    icon: linkIcons.holidaysManagement,
    displayRoles: roles.holidays,
    displayFeature: features.holidays,
  },
  {
    to: '/project-tracking',
    name: 'menu.project_tracking',
    icon: linkIcons.workingHours,
    displayRoles: roles.user,
    displayFeature: features.projects,
  },
  {
    to: '/projects',
    name: 'menu.projects',
    icon: linkIcons.projects,
    displayRoles: roles.projects,
    displayFeature: features.projects,
  },
  {
    to: '/clients',
    name: 'menu.clients',
    icon: linkIcons.clients,
    displayRoles: roles.clients,
    displayFeature: features.clients,
  },
  {
    to: '/transactions',
    name: 'menu.bank_accounts',
    icon: linkIcons.transactions,
    displayRoles: [
      ...roles.banksManager,
      ...roles.transactionsManager,
      ...roles.accountancy,
    ],
    displayFeature: features.transactions,
  },
  {
    to: '/invoices',
    name: 'menu.invoices',
    icon: linkIcons.invoices,
    displayRoles: roles.invoices,
  },
  {
    to: '/contractors',
    name: 'menu.costs',
    icon: linkIcons.contractors,
    displayRoles: roles.contractors,
  },
  {
    to: '/payment-due',
    name: 'menu.payment_due',
    icon: linkIcons.paymentDue,
    displayRoles: roles.paymentDue,
  },
  {
    to: '/budget',
    name: 'menu.budget',
    icon: linkIcons.budget,
    displayRoles: [
      ...roles.budgetManager,
      ...roles.budgetViewer,
    ],
  },
  {
    to: '/transaction-attachments',
    name: 'menu.transaction_attachments',
    icon: linkIcons.transactionAttachments,
    displayRoles: [
      ...roles.transactionsManager,
      ...roles.accountancy,
      ...roles.debtCollection,
    ],
    displayFeature: features.transactions,
  },
  {
    to: '/responsibilities',
    name: 'menu.responsibilites',
    icon: linkIcons.responsibilities,
    displayRoles: roles.responsibilitiesManager,
    displayFeature: features.responsibilities,
  },
  {
    to: '/feedback',
    name: 'menu.feedback',
    icon: linkIcons.feedback,
    displayRoles: roles.user,
    displayFeature: features.feedback,
  },
  {
    to: '/property-booking',
    name: 'menu.property_booking',
    icon: linkIcons.propertyBooking,
    displayRoles: roles.properties,
    displayFeature: features.bookings,
  },
  {
    to: '/accountancy',
    name: 'menu.accountancy',
    icon: linkIcons.accountancy,
    displayRoles: roles.accountancy,
  },
];

export default menuLinks;
